<template>
  <div style="width: 100%">
    <applys mode="Mall-order" :target="id" />
    <el-form ref="ff" v-loading="loading">
      <el-form-item>
        <el-input type="textarea" :rows="5" v-model="msg" />
      </el-form-item>
      <div class="toolbar">
        <el-link type="danger" @click="onApply">上报审核（转审）</el-link>
        <label style="flex: 1" />
        <el-button type="primary" @click="onSubmit(true)">审定</el-button>
        <el-button type="info" @click="onSubmit(false)">退回</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  components: {
    applys: () => import("@/views/company/audit/_record.vue")
  },
  props: {
    id: { type: String },
    msg: { type: String },
    callback: { type: Function },
    layerid: { type: String, default: null }
  },
  data () {
    return {
      loading: false,
      applys: []
    }
  },
  created () {
    this.loadApplys()
  },
  methods: {
    //获取转审内容
    loadApplys () {
      this.$apis.mall.order.approval({
        mode: 'Mall-Order',
        target: this.id
      }).then(res => {
        this.applys = res.Items
      })
    },
    //转审
    onApply () {
      this.callback(false)
      this.$layer.close(this.layerid)
    },
    //审核
    onSubmit (state = true) {
      this.$apis.mall.order.approval({
        id: this.id,
        state: state,
        msg: this.msg
      }).then(() => {
        this.callback(true)
        this.$layer.close(this.layerid)
      }).catch((e) => {
        this.$message.error(e || "系统错误")
      })
    }
  }
}
</script>

<style>
</style>